var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[(_vm.levelValue)?_c('span',[_vm._v(_vm._s(_vm.levelValue))]):_vm._e(),_c('div',{staticClass:"block",style:(("background-color: " + _vm.levelColor))})])}
var staticRenderFns = []

export { render, staticRenderFns }